/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeinteractivemap3Inputs */

const zh_learn_mistakestypeinteractivemap3 = /** @type {(inputs: Learn_Mistakestypeinteractivemap3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交互地图`)
};

const en_learn_mistakestypeinteractivemap3 = /** @type {(inputs: Learn_Mistakestypeinteractivemap3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive Map`)
};

const es_learn_mistakestypeinteractivemap3 = /** @type {(inputs: Learn_Mistakestypeinteractivemap3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa interactivo`)
};

/**
* | output |
* | --- |
* | "Interactive Map" |
*
* @param {Learn_Mistakestypeinteractivemap3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeinteractivemap3 = /** @type {((inputs?: Learn_Mistakestypeinteractivemap3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeinteractivemap3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeinteractivemap3(inputs)
	if (locale === "en") return en_learn_mistakestypeinteractivemap3(inputs)
	return es_learn_mistakestypeinteractivemap3(inputs)
});
export { learn_mistakestypeinteractivemap3 as "learn_mistakesTypeInteractiveMap" }